import { combineReducers } from '@reduxjs/toolkit';

import { mapReducer } from './mapReducer';
import { tabsReducer } from './tabsReducer';

export const mapV2Reducer = combineReducers({
  map: mapReducer,
  tabs: tabsReducer,
});
